module.exports = __webpack_public_path__ + "static/img/tc1.d8acaa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/tc1.png
// module id = 7+Nz
// module chunks = 1